import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { useEmailAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/EmailAccountProvider/useEmailAccount";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as EmailIcon } from "./assets/email.svg";

export const EmailTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const { openManageAccountDrawer } = useManageAccountsDrawer();
  const { emailAccount, isConnected } = useEmailAccount();

  const isGmailConnected = emailAccount?.type === "gmail";
  const isEmailForwardingVerified =
    !!emailAccount?.metadata?.email_forwarding_verified;
  const statusType =
    isGmailConnected || isEmailForwardingVerified
      ? "connected"
      : isConnected
        ? "verify"
        : undefined;

  return (
    <ChannelTile
      title={t({
        id: "client-support-page.email",
        defaultMessage: "Email",
      })}
      isConnected={isConnected}
      onClick={() =>
        openManageAccountDrawer({
          name: isConnected ? "emailAccount" : "emailSetup",
        })
      }
      description={
        emailAccount
          ? emailAccount.email
          : t({
              id: "cx-ai-agents-page.business-conversation-via-email",
              defaultMessage: "Business conversation via Email",
            })
      }
      icon={<EmailIcon />}
      status={
        statusType
          ? {
              type: statusType,
              text:
                statusType === "connected"
                  ? t({
                      id: "common.connected",
                      defaultMessage: "Connected",
                    })
                  : t({
                      id: "client-support-page.verify",
                      defaultMessage: "Verify",
                    }),
            }
          : undefined
      }
      {...props}
    />
  );
};
